import { Channel } from "@at/sauron-platform-core";

import { useGetCanonicalUrl } from "./use-get-canonical-url-hook";
import { ProductPageQuery_search_Search_advert_Advert } from "../../connected-components/hoc/query/__generated__/pdp-page-data.query";
import { getCapitalizedSingularChannel } from "../channel/channel-utils";
import { setMetaData } from "../leasing/setMetaData/set-meta-data";

export const usePageData = (
  advert: ProductPageQuery_search_Search_advert_Advert | undefined,
  channel: Channel,
) => {
  const { make, model, trim, doors } = advert?.specification || {};
  const { bodyType } = advert?.generation || {};
  const imageUrl = advert?.imageList?.images[0]?.url
    ? advert.imageList?.images[0]?.url.replace("{resize}/", "")
    : "";
  const formattedChannel = getCapitalizedSingularChannel(channel);
  const canonical = useGetCanonicalUrl();

  // Ensure both make and model exist, if not give a generic title and description
  if (!make || !model) {
    return {
      metaTitle: `${formattedChannel} Lease Deals | AutoTrader UK`,
      metaDescription: `Lease a ${formattedChannel.toLowerCase()} on AutoTrader. Free 30-day returns and road tax included along with free delivery to your door!`,
    };
  }

  // Filter out any undefined or null values
  const details = [
    make,
    model,
    trim,
    bodyType,
    doors ? `${doors} Doors` : null,
  ].filter(Boolean);

  const vehicleDetails = details.join(" ");

  const metaTitle = `${vehicleDetails} Lease Deal | AutoTrader UK`;
  const metaDescription = `Lease a ${vehicleDetails} on AutoTrader. Free 30-day returns and road tax included along with free delivery to your door!`;
  setMetaData(metaTitle, metaDescription, canonical, imageUrl);

  return { metaTitle, metaDescription, canonical };
};
